export default __webpack_public_path__ + "static/media/sencha.73da74d7.svg";